import React, { useState, useRef, useEffect } from 'react';
import client, { apiCall } from '../../api/client';
import { useAuth } from '../../context/AuthContext';

export default function Profile() {
  const { user, logout } = useAuth();
  const [form, setForm] = useState({ currentPassword: '', newPassword: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const logoutTimeoutRef = useRef(null);

  useEffect(() => () => clearTimeout(logoutTimeoutRef.current), []);

  const initials = (user?.name || '?')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      await apiCall(client.post('/users/change_password', form));
      setSuccess('Password updated. Please log in again.');
      setForm({ currentPassword: '', newPassword: '' });
      logoutTimeoutRef.current = setTimeout(logout, 1500);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1>Profile</h1>

      <div className="profile-header">
        <div className="profile-avatar">{initials || '?'}</div>
        <div>
          <p className="profile-name">{user?.name}</p>
          <p className="profile-id">Account ID: {user?.id}</p>
        </div>
      </div>

      <div className="profile-grid">
        <div className="card">
          <p className="profile-section-title">Account</p>
          <p className="profile-section-desc">Basic details tied to your account.</p>
          <div className="form-group">
            <label>Full name</label>
            <input value={user?.name || ''} disabled />
          </div>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>Account ID</label>
            <input value={user?.id || ''} disabled />
          </div>
        </div>

        <div className="card">
          <p className="profile-section-title">Change password</p>
          <p className="profile-section-desc">You'll be logged out after updating your password.</p>
          {error && <div className="form-error">{error}</div>}
          {success && <div className="form-success">{success}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Current password</label>
              <input type="password" name="currentPassword" required value={form.currentPassword} onChange={handleChange} />
            </div>
            <div className="form-group" style={{ marginBottom: 20 }}>
              <label>New password</label>
              <input type="password" name="newPassword" required value={form.newPassword} onChange={handleChange} />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Updating...' : 'Update password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
